import { useModel as _useModel, defineComponent as _defineComponent } from 'vue'
import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, unref as _unref, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "mb-4 simple-patterns" }

import { type DayType, DAYS } from './date_time_range_generators';

export default /*@__PURE__*/_defineComponent({
  __name: 'DayPatterns',
  props: {
    "modelValue": {
  type: Array as () => DayType[]
},
    "modelModifiers": {},
  },
  emits: ["update:modelValue"],
  setup(__props) {

const selectedDays = _useModel<DayType[]>(__props, "modelValue");

return (_ctx: any,_cache: any) => {
  const _component_v_btn = _resolveComponent("v-btn")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_v_btn, {
      size: "x-small",
      variant: "outlined",
      class: "mr-2 mb-2",
      onClick: _cache[0] || (_cache[0] = ($event: any) => (selectedDays.value = ['Monday','Tuesday','Wednesday','Thursday','Friday']))
    }, {
      default: _withCtx(() => [...(_cache[4] || (_cache[4] = [
        _createTextVNode("Weekdays", -1)
      ]))]),
      _: 1
    }),
    _createVNode(_component_v_btn, {
      size: "x-small",
      variant: "outlined",
      class: "mr-2 mb-2",
      onClick: _cache[1] || (_cache[1] = ($event: any) => (selectedDays.value = ['Sunday','Saturday']))
    }, {
      default: _withCtx(() => [...(_cache[5] || (_cache[5] = [
        _createTextVNode("Weekends", -1)
      ]))]),
      _: 1
    }),
    _createVNode(_component_v_btn, {
      size: "x-small",
      variant: "outlined",
      class: "mr-2 mb-2",
      onClick: _cache[2] || (_cache[2] = ($event: any) => (selectedDays.value = _unref(DAYS).slice()))
    }, {
      default: _withCtx(() => [...(_cache[6] || (_cache[6] = [
        _createTextVNode("Full Week", -1)
      ]))]),
      _: 1
    }),
    _createVNode(_component_v_btn, {
      size: "x-small",
      variant: "outlined",
      class: "mr-2 mb-2",
      onClick: _cache[3] || (_cache[3] = ($event: any) => (selectedDays.value = []))
    }, {
      default: _withCtx(() => [...(_cache[7] || (_cache[7] = [
        _createTextVNode("Clear", -1)
      ]))]),
      _: 1
    })
  ]))
}
}

})